export default "__VITE_ASSET__e331d635__"